var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.deviceTypeCode)?_c('deviceList',{attrs:{"deviceTypeCode":_vm.deviceTypeCode,"showMonitorRangeColumn":false,"showOperationColumn":false,"linkParam":_vm.linkParam,"locationSetName":_vm.locationSetName}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }